/**
 * A/B Test — Packing USP option cards + info popups
 * Toggle: body[data-packing-usp-ab="true|false"]
 *   - false (Control): existing USP options as-is (no popups)
 *   - true  (Variant): wire existing USP options to centered info popups
 *
 * Does NOT inject a second set of cards — utilizes the options already on the PDP.
 *
 * Vacuum Kit / Vacuum Bag / Vacuum Pump PDPs.
 * For Intelligems, set data-packing-usp-ab on <body>.
 * Dev preview: ?packing_usp_test=b
 */
(function () {
  'use strict';

  if (window.__packingUspAbInit) return;
  window.__packingUspAbInit = true;

  var ATTR = 'data-packing-usp-ab';
  var OPTION_ATTR = 'data-packing-usp-open';
  var ENHANCED_ATTR = 'data-packing-usp-enhanced';
  var ACTIVE_CLASS = 'packing-usp-ab--active';
  var MODAL_ID = 'packing-usp-ab-modal';
  var ORANGE = '#FF5801';

  var applying = false;
  var rafScheduled = false;
  var lastEnabled = null;
  var lastAttrValue = null;
  var modalEl = null;
  var lastFocused = null;
  var enhancedNodes = [];
  var domObserver = null;

  var ICON_CLOSE =
    '<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="M4.5 4.5l9 9M13.5 4.5l-9 9" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>' +
    '</svg>';

  var CAPACITY_ICONS = {
    one:
      '<svg width="36" height="28" viewBox="0 0 40 30" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="M6 8.08L12 3.63C13.5 6.6 15.5 7.59 18 7.59C20.5 7.59 22.5 6.6 24 3.63L30 8.08L26 12.53L24 10.55V24.89H12V10.55L10 12.53L6 8.08Z" fill="white" stroke="' +
      ORANGE +
      '" stroke-width="1.45"/>' +
      '</svg>',
    two:
      '<svg width="36" height="28" viewBox="0 0 40 31" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="M12 8.35L18 3.75C19.5 6.82 21.5 7.84 24 7.84C26.5 7.84 28.5 6.82 30 3.75L36 8.35L32 12.95L30 10.9V25.72H18V10.9L16 12.95L12 8.35Z" fill="white" stroke="' +
      ORANGE +
      '" stroke-width="1.45"/>' +
      '<path d="M4 8.35L10 3.75C11.5 6.82 13.5 7.84 16 7.84C18.5 7.84 20.5 6.82 22 3.75L28 8.35L24 12.95L22 10.9V25.72H10V10.9L8 12.95L4 8.35Z" fill="white" stroke="' +
      ORANGE +
      '" stroke-width="1.45"/>' +
      '</svg>',
    four:
      '<svg width="36" height="28" viewBox="0 0 36 27" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="M12.6 7.27L18 3.27C19.35 5.94 21.15 6.83 23.4 6.83C25.65 6.83 27.45 5.94 28.8 3.27L34.2 7.27L30.6 11.28L28.8 9.5V22.4H18V9.5L16.2 11.28L12.6 7.27Z" fill="white" stroke="' +
      ORANGE +
      '" stroke-width="1.45"/>' +
      '<path d="M7.2 7.27L12.6 3.27C13.95 5.94 15.75 6.83 18 6.83C20.25 6.83 22.05 5.94 23.4 3.27L28.8 7.27L25.2 11.28L23.4 9.5V22.4H12.6V9.5L10.8 11.28L7.2 7.27Z" fill="white" stroke="' +
      ORANGE +
      '" stroke-width="1.45"/>' +
      '<path d="M1.8 7.27L7.2 3.27C8.55 5.94 10.35 6.83 12.6 6.83C14.85 6.83 16.65 5.94 18 3.27L23.4 7.27L19.8 11.28L18 9.5V22.4H7.2V9.5L5.4 11.28L1.8 7.27Z" fill="white" stroke="' +
      ORANGE +
      '" stroke-width="1.45"/>' +
      '</svg>'
  };

  var MATCHERS = [
    { key: 'pack', test: /pack\s*15|15\+\s*items/i },
    { key: 'pump', test: /air\s*pump/i },
    { key: 'luggage', test: /fits\s*any|any\s*bag|suitcase/i },
    { key: 'fees', test: /baggage|airline|check-?in\s*lines/i }
  ];

  function scriptEl() {
    return document.querySelector('script[src*="packing-usp-ab-test"]');
  }

  function assetUrl(key, fallback) {
    var s = scriptEl();
    if (!s) return fallback || '';
    return s.getAttribute('data-' + key) || fallback || '';
  }

  function getPanels() {
    var imgPack = assetUrl(
      'img-pack',
      'https://cdn.shopify.com/s/files/1/0924/3502/2169/files/Container_31.png?v=1790332473&width=1600'
    );
    var imgPump = assetUrl(
      'img-pump',
      'https://cdn.shopify.com/s/files/1/0924/3502/2169/files/Container_28.png?v=1790332433&width=1600'
    );
    var imgLuggage = assetUrl(
      'img-luggage',
      'https://cdn.shopify.com/s/files/1/0924/3502/2169/files/Container_29.png?v=1790332429&width=1600'
    );
    var imgFees = assetUrl(
      'img-fees',
      'https://cdn.shopify.com/s/files/1/0924/3502/2169/files/Container_30.png?v=1790332427&width=1600'
    );

    return {
      pack: {
        key: 'pack',
        title: 'Pack More in Less Space',
        desc:
          'Compress bulky clothes, jackets, and other soft items to free up valuable space in your luggage. Perfect for longer trips or heavy packers.',
        heroSrc: imgPack,
        heroAlt: '3x more packing space with Aerless',
        showCapacity: true
      },
      pump: {
        key: 'pump',
        title: 'Compact Air Pump Included',
        desc:
          'Use the included portable air pump to quickly remove excess air and compress your packing bags — no separate vacuum required.',
        heroSrc: imgPump,
        heroAlt: 'Aerless compact air pump',
        showCapacity: false
      },
      luggage: {
        key: 'luggage',
        title: 'Made for Any Luggage',
        desc:
          'Designed to fit easily inside carry-ons, suitcases, backpacks and travel bags, so you can stay organized wherever you go.',
        heroSrc: imgLuggage,
        heroAlt: 'Compress 15+ clothing items for 60% more space',
        showCapacity: false
      },
      fees: {
        key: 'fees',
        title: 'Travel Smarter & Save Money',
        desc:
          'Save space and fit more into your existing luggage, helping reduce the need for additional checked bags and extra baggage fees.',
        heroSrc: imgFees,
        heroAlt: 'Airplane taking off',
        showCapacity: false
      }
    };
  }

  function isDevVariantB() {
    try {
      return new URLSearchParams(window.location.search).get('packing_usp_test') === 'b';
    } catch (e) {
      return false;
    }
  }

  function isTruthy(value) {
    var normalized = String(value || '')
      .trim()
      .toLowerCase();
    return normalized === 'true' || normalized === '1' || normalized === 'on' || normalized === 'yes';
  }

  function isAbEnabled() {
    if (isDevVariantB()) return true;
    if (!document.body) return false;
    return (
      isTruthy(document.body.getAttribute(ATTR)) ||
      isTruthy(document.documentElement.getAttribute(ATTR))
    );
  }

  function isTargetPdp() {
    if (!document.body) return false;
    if (document.querySelector('product-gallery[data-gallery-vacuum-kit-pdp="true"]')) return true;
    var path = String(location.pathname || '').toLowerCase();
    return (
      path.indexOf('vacuum-kit') > -1 ||
      path.indexOf('aerless-vacuum-kit') > -1 ||
      path.indexOf('vacuum-bag') > -1 ||
      path.indexOf('vacuum-pump') > -1 ||
      path.indexOf('aerless%E2%84%A2-vacuum-kit') > -1
    );
  }

  function getUspBlock() {
    var grid = document.querySelector('.usp-feature-grid');
    if (grid) {
      return (
        grid.closest('[data-block-type="usplist"]') ||
        grid.closest('.product-info__block-item') ||
        grid.parentElement ||
        grid
      );
    }

    var block = document.querySelector('div[data-block-type="usplist"]');
    if (block) return block;

    var heading = document.querySelector('.usp_heading');
    if (!heading) return null;
    return (
      heading.closest('[data-block-type="usplist"]') ||
      heading.closest('.product-info__block-item') ||
      heading.parentElement
    );
  }

  function matchKey(text) {
    var value = String(text || '');
    for (var i = 0; i < MATCHERS.length; i++) {
      if (MATCHERS[i].test.test(value)) return MATCHERS[i].key;
    }
    return null;
  }

  function collectCandidateNodes(uspBlock) {
    var scope = uspBlock || document;
    var nodes = [];

    /* Primary: existing USP feature grid cards */
    var cards = scope.querySelectorAll
      ? scope.querySelectorAll('.usp-feature-grid__card')
      : [];
    if (!cards.length) {
      cards = document.querySelectorAll('.usp-feature-grid__card');
    }
    if (cards.length) {
      for (var i = 0; i < cards.length; i++) nodes.push(cards[i]);
      return nodes;
    }

    /* Fallback: list items / labeled nodes */
    if (!uspBlock) return nodes;

    var listItems = uspBlock.querySelectorAll('li');
    if (listItems.length) {
      for (var j = 0; j < listItems.length; j++) nodes.push(listItems[j]);
      return nodes;
    }

    return nodes;
  }

  function buildCapacityHtml() {
    return (
      '<div class="packing-usp-ab-modal__capacity">' +
      '<div class="packing-usp-ab-modal__cap-cell">' +
      '<div class="packing-usp-ab-modal__cap-icon">' +
      CAPACITY_ICONS.one +
      '</div>' +
      '<div class="packing-usp-ab-modal__cap-outfits">15+ outfits</div>' +
      '<div class="packing-usp-ab-modal__cap-pack">with the 1 Pack</div>' +
      '</div>' +
      '<div class="packing-usp-ab-modal__cap-cell">' +
      '<div class="packing-usp-ab-modal__cap-icon">' +
      CAPACITY_ICONS.two +
      '</div>' +
      '<div class="packing-usp-ab-modal__cap-outfits">30+ outfits</div>' +
      '<div class="packing-usp-ab-modal__cap-pack">with the 2 Pack</div>' +
      '</div>' +
      '<div class="packing-usp-ab-modal__cap-cell">' +
      '<div class="packing-usp-ab-modal__cap-icon">' +
      CAPACITY_ICONS.four +
      '</div>' +
      '<div class="packing-usp-ab-modal__cap-outfits">60+ outfits</div>' +
      '<div class="packing-usp-ab-modal__cap-pack">with the 4 Pack</div>' +
      '</div>' +
      '</div>'
    );
  }

  function imageUrl(base, width) {
    if (!base) return '';
    var url = String(base);
    if (/[?&]width=\d+/i.test(url)) {
      return url.replace(/([?&])width=\d+/i, '$1width=' + width);
    }
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function buildHeroHtml(panel) {
    if (!panel.heroSrc) return '';
    var src1x = imageUrl(panel.heroSrc, 800);
    var src2x = imageUrl(panel.heroSrc, 1600);
    return (
      '<div class="packing-usp-ab-modal__hero packing-usp-ab-modal__hero--image">' +
      '<img src="' +
      src1x +
      '" srcset="' +
      src1x +
      ' 800w, ' +
      src2x +
      ' 1600w" sizes="(max-width: 430px) 92vw, 400px" alt="' +
      (panel.heroAlt || '') +
      '" loading="eager" decoding="async" width="800" height="500">' +
      '</div>'
    );
  }

  function ensureModal() {
    if (modalEl && document.body.contains(modalEl)) return modalEl;

    modalEl = document.createElement('div');
    modalEl.id = MODAL_ID;
    modalEl.className = 'packing-usp-ab-modal';
    modalEl.setAttribute('data-open', 'false');
    modalEl.setAttribute('aria-hidden', 'true');
    modalEl.innerHTML =
      '<div class="packing-usp-ab-modal__backdrop" data-packing-usp-close></div>' +
      '<div class="packing-usp-ab-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="packing-usp-ab-title" tabindex="-1">' +
      '<button type="button" class="packing-usp-ab-modal__close" data-packing-usp-close aria-label="Close">' +
      ICON_CLOSE +
      '</button>' +
      '<div class="packing-usp-ab-modal__media" data-packing-usp-media></div>' +
      '<h2 class="packing-usp-ab-modal__title" id="packing-usp-ab-title" data-packing-usp-title></h2>' +
      '<p class="packing-usp-ab-modal__desc" data-packing-usp-desc></p>' +
      '<div class="packing-usp-ab-modal__extra" data-packing-usp-extra></div>' +
      '<button type="button" class="packing-usp-ab-modal__got-it" data-packing-usp-close>Got it</button>' +
      '</div>';

    document.body.appendChild(modalEl);
    return modalEl;
  }

  function renderPanel(key) {
    var panels = getPanels();
    var panel = panels[key];
    if (!panel) return;

    var modal = ensureModal();
    var media = modal.querySelector('[data-packing-usp-media]');
    var title = modal.querySelector('[data-packing-usp-title]');
    var desc = modal.querySelector('[data-packing-usp-desc]');
    var extra = modal.querySelector('[data-packing-usp-extra]');

    if (media) media.innerHTML = buildHeroHtml(panel);
    if (title) title.textContent = panel.title;
    if (desc) desc.textContent = panel.desc;
    if (extra) extra.innerHTML = panel.showCapacity ? buildCapacityHtml() : '';
  }

  function openModal(key) {
    renderPanel(key);
    var modal = ensureModal();
    lastFocused = document.activeElement;
    modal.setAttribute('data-open', 'true');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('packing-usp-ab-modal-open');
    var dialog = modal.querySelector('.packing-usp-ab-modal__dialog');
    if (dialog) dialog.focus();
  }

  function closeModal() {
    if (!modalEl) return;
    modalEl.setAttribute('data-open', 'false');
    modalEl.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('packing-usp-ab-modal-open');
    if (lastFocused && typeof lastFocused.focus === 'function') {
      try {
        lastFocused.focus();
      } catch (e) {}
    }
  }

  function removeInjectedDuplicates() {
    var leftovers = document.querySelectorAll(
      '.packing-usp-ab, [data-packing-usp-ab-root], [data-packing-usp-ab-injected]'
    );
    for (var i = 0; i < leftovers.length; i++) {
      if (leftovers[i].parentNode) leftovers[i].parentNode.removeChild(leftovers[i]);
    }
  }

  function clearEnhancements() {
    for (var i = 0; i < enhancedNodes.length; i++) {
      var node = enhancedNodes[i];
      if (!node) continue;
      node.removeAttribute(OPTION_ATTR);
      node.removeAttribute(ENHANCED_ATTR);
      node.removeAttribute('role');
      node.removeAttribute('tabindex');
      node.removeAttribute('aria-haspopup');
      node.classList.remove('packing-usp-ab__option');
    }
    enhancedNodes = [];

    var marked = document.querySelectorAll('[' + ENHANCED_ATTR + ']');
    for (var j = 0; j < marked.length; j++) {
      marked[j].removeAttribute(OPTION_ATTR);
      marked[j].removeAttribute(ENHANCED_ATTR);
      marked[j].removeAttribute('role');
      marked[j].removeAttribute('tabindex');
      marked[j].removeAttribute('aria-haspopup');
      marked[j].classList.remove('packing-usp-ab__option');
    }

    var hosts = document.querySelectorAll('.packing-usp-ab__host');
    for (var h = 0; h < hosts.length; h++) {
      hosts[h].classList.remove('packing-usp-ab__host');
    }
  }

  function enhanceExistingOptions() {
    removeInjectedDuplicates();
    clearEnhancements();

    var uspBlock = getUspBlock();
    var candidates = collectCandidateNodes(uspBlock);
    if (!candidates.length) return false;

    var orderFallback = ['pack', 'pump', 'luggage', 'fees'];
    var used = {};
    var count = 0;

    for (var i = 0; i < candidates.length; i++) {
      var node = candidates[i];
      var labelEl = node.querySelector('.usp-feature-grid__label');
      var imgEl = node.querySelector('.usp-feature-grid__icon img, img');
      var text =
        (labelEl && labelEl.textContent) ||
        (imgEl && imgEl.getAttribute('alt')) ||
        node.textContent;
      var key = matchKey(text);

      /* Stable order fallback for the known 4-card grid */
      if (!key && node.classList.contains('usp-feature-grid__card') && i < orderFallback.length) {
        key = orderFallback[i];
      }

      if (!key || used[key]) continue;

      used[key] = true;
      count += 1;
      node.setAttribute(OPTION_ATTR, key);
      node.setAttribute(ENHANCED_ATTR, 'true');
      node.setAttribute('role', 'button');
      node.setAttribute('tabindex', '0');
      node.setAttribute('aria-haspopup', 'dialog');
      node.classList.add('packing-usp-ab__option');
      enhancedNodes.push(node);
    }

    if (count) {
      var grid = document.querySelector('.usp-feature-grid');
      if (grid) grid.classList.add('packing-usp-ab__host');
      if (uspBlock) uspBlock.classList.add('packing-usp-ab__host');
    }

    return count > 0;
  }

  function applyVariant() {
    if (applying) return;
    applying = true;

    try {
      var enabled = isAbEnabled() && isTargetPdp();

      if (document.body) {
        document.body.classList.toggle(ACTIVE_CLASS, enabled);
      }
      document.documentElement.classList.toggle('packing-usp-ab-b', enabled);

      removeInjectedDuplicates();

      if (enabled === lastEnabled) {
        if (enabled && !document.querySelector('[' + ENHANCED_ATTR + '="true"]')) {
          enhanceExistingOptions();
        }
        return;
      }

      lastEnabled = enabled;

      if (!enabled) {
        clearEnhancements();
        closeModal();
        return;
      }

      enhanceExistingOptions();
    } finally {
      applying = false;
    }
  }

  function resolveCardKey(card) {
    if (!card) return null;
    if (card.getAttribute(OPTION_ATTR)) return card.getAttribute(OPTION_ATTR);

    var labelEl = card.querySelector('.usp-feature-grid__label');
    var imgEl = card.querySelector('.usp-feature-grid__icon img, img');
    var text =
      (labelEl && labelEl.textContent) ||
      (imgEl && imgEl.getAttribute('alt')) ||
      card.textContent;
    var key = matchKey(text);
    if (key) return key;

    var grid = card.closest('.usp-feature-grid');
    if (grid) {
      var cards = grid.querySelectorAll('.usp-feature-grid__card');
      var orderFallback = ['pack', 'pump', 'luggage', 'fees'];
      for (var i = 0; i < cards.length; i++) {
        if (cards[i] === card && i < orderFallback.length) return orderFallback[i];
      }
    }
    return null;
  }

  function scheduleApply() {
    if (rafScheduled) return;
    rafScheduled = true;
    requestAnimationFrame(function () {
      rafScheduled = false;
      applyVariant();
    });
  }

  function onDocumentClick(event) {
    if (!isAbEnabled() || !isTargetPdp()) {
      var closeOnly = event.target.closest && event.target.closest('[data-packing-usp-close]');
      if (closeOnly) {
        event.preventDefault();
        closeModal();
      }
      return;
    }

    var card =
      event.target.closest &&
      event.target.closest('.usp-feature-grid__card, [' + OPTION_ATTR + ']');
    if (card) {
      var key = resolveCardKey(card);
      if (key) {
        event.preventDefault();
        openModal(key);
      }
      return;
    }

    var closeBtn = event.target.closest && event.target.closest('[data-packing-usp-close]');
    if (closeBtn) {
      event.preventDefault();
      closeModal();
    }
  }

  function onKeydown(event) {
    if (event.key === 'Escape' && modalEl && modalEl.getAttribute('data-open') === 'true') {
      closeModal();
      return;
    }

    if ((event.key === 'Enter' || event.key === ' ') && isAbEnabled() && isTargetPdp()) {
      var card =
        event.target &&
        event.target.closest &&
        event.target.closest('.usp-feature-grid__card, [' + OPTION_ATTR + ']');
      if (card) {
        var key = resolveCardKey(card);
        if (key) {
          event.preventDefault();
          openModal(key);
        }
      }
    }
  }

  function nodeLooksLikeUsp(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.getAttribute && node.getAttribute('data-block-type') === 'usplist') return true;
    if (node.classList) {
      if (
        node.classList.contains('usp_heading') ||
        node.classList.contains('usp-feature-grid') ||
        node.classList.contains('usp-feature-grid__card') ||
        node.classList.contains('product-info__text')
      ) {
        return true;
      }
    }
    if (node.querySelector) {
      return !!(
        node.querySelector('.usp-feature-grid') ||
        node.querySelector('.usp-feature-grid__card') ||
        node.querySelector('[data-block-type="usplist"]') ||
        node.querySelector('.usp_heading')
      );
    }
    return false;
  }

  function startObservers() {
    if (!document.documentElement || !window.MutationObserver) return;
    if (domObserver) return;

    domObserver = new MutationObserver(function (mutations) {
      var i;
      var next;
      var node;
      var shouldApply = false;

      for (i = 0; i < mutations.length; i++) {
        if (mutations[i].type === 'attributes') {
          if (
            mutations[i].attributeName === ATTR &&
            (mutations[i].target === document.body ||
              mutations[i].target === document.documentElement)
          ) {
            next =
              document.body.getAttribute(ATTR) ||
              document.documentElement.getAttribute(ATTR);
            if (next !== lastAttrValue) {
              lastAttrValue = next;
              lastEnabled = null;
              shouldApply = true;
            }
          }
          continue;
        }

        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          for (var j = 0; j < mutations[i].addedNodes.length; j++) {
            node = mutations[i].addedNodes[j];
            if (nodeLooksLikeUsp(node)) {
              shouldApply = true;
              break;
            }
          }
        }
        if (shouldApply) break;
      }

      if (shouldApply) scheduleApply();
    });

    domObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: [ATTR],
      childList: true,
      subtree: true
    });
  }

  function boot() {
    lastAttrValue = document.body ? document.body.getAttribute(ATTR) : null;
    startObservers();
    applyVariant();

    document.addEventListener('click', onDocumentClick, true);
    document.addEventListener('keydown', onKeydown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
